import { useState,React } from "react";
import {  Paper, Text, ThemeIcon, Group,  Grid, Button, Stack,Container, TextInput } from '@mantine/core';
import { RichTextEditor } from '@mantine/tiptap';
import { useEditor } from '@tiptap/react';
import Highlight from '@tiptap/extension-highlight';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import { useForm } from "@mantine/form";
import TextAlign from '@tiptap/extension-text-align';
import Superscript from '@tiptap/extension-superscript';
import SubScript from '@tiptap/extension-subscript';
import { IconCar, IconPhone } from '@tabler/icons-react';
import { useQuery,useMutation } from 'react-query';
import { Link,useNavigate,useParams } from "react-router-dom";
import FollowUp from "./followUp";
import {closeChrono,inProgChrono,postFollowUp,fetchChronoByID, patchChrono} from "../connections/requests";

function getIcon(type) {
    switch (type) {
        case "transport":
            return <IconCar size={28} stroke={1.5} />
        case "phone":
            return <IconPhone size={28} stroke={1.5} />

        default:
            break;
    }
};

export default function ChronoEdit() {
    let { suivi } = useParams();
    const {data,status,refetch} = useQuery(['chronos',suivi],fetchChronoByID);
    const mutation = useMutation((data) => postFollowUp(data));
    const closeMutation = useMutation((id) => closeChrono(id, setStatus("closed")));
    const progMutation = useMutation((id) => inProgChrono(id, setStatus("inProg")));
    const [opened, setOpened] = useState(false);
    const [sstatus, setStatus] = useState("closed");
    const [init, setInit] = useState(false);
    const navigate = useNavigate();
    const form = useForm()
    const editor = useEditor({
    extensions: [
        StarterKit,
        Underline,
        Link,
        Superscript,
        SubScript,
        Highlight,
        TextAlign.configure({ types: ['heading', 'paragraph'] }),
    ],
    content:"",
});
if(status === "success" && editor) {
    if(!init) {setInit(true);form.setValues({...data,worker:data?.worker?.id,member:data?.member?.id});editor?.commands.setContent(data.description)}
    return (
    <Container bg={"white"} p={"xl"} m={"xl"} size={"xl"}>
        <form>
        <Grid my={"xs"}>
                    <Grid.Col span={1}>
                        <ThemeIcon
                            size="xl"
                            radius="md"
                            variant="gradient"
                            gradient={{ deg: 0, from: 'pink', to: 'orange' }}
                        >
                            {getIcon(data.type)}
                        </ThemeIcon>
                    </Grid.Col>
                    <Grid.Col span={5}>
                        <TextInput label="Titre" {...form.getInputProps('titre')}/>
                    </Grid.Col>
                    <Grid.Col span={5}>
                        <Stack>
                            {form.values?.worker ? <TextInput label="Travailleur" {...form.getInputProps("worker")} /> : <TextInput  label="Travailleur" {...form.getInputProps("worker")} />}
                            {form.values?.member ? <TextInput label="Member" {...form.getInputProps("member")} /> : <TextInput  label="Member" {...form.getInputProps("member")} />}                            
                        </Stack>
                    </Grid.Col>
                </Grid>
                <Text weight={"bolder"}>Description : </Text>
                <RichTextEditor my={"lg"} py={"sm"} editor={editor}>
                    <RichTextEditor.Toolbar sticky stickyOffset={60}>
                        <RichTextEditor.ControlsGroup>
                            <RichTextEditor.Bold />
                            <RichTextEditor.Italic />
                            <RichTextEditor.Underline />
                            <RichTextEditor.Strikethrough />
                            <RichTextEditor.ClearFormatting />
                            <RichTextEditor.Highlight />
                            <RichTextEditor.Code />
                        </RichTextEditor.ControlsGroup>
                        <RichTextEditor.ControlsGroup>
                            <RichTextEditor.H1 />
                            <RichTextEditor.H2 />
                            <RichTextEditor.H3 />
                            <RichTextEditor.H4 />
                        </RichTextEditor.ControlsGroup>

                        <RichTextEditor.ControlsGroup>
                            <RichTextEditor.Blockquote />
                            <RichTextEditor.Hr />
                            <RichTextEditor.BulletList />
                            <RichTextEditor.OrderedList />
                            <RichTextEditor.Subscript />
                            <RichTextEditor.Superscript />
                        </RichTextEditor.ControlsGroup>

                        <RichTextEditor.ControlsGroup>
                            <RichTextEditor.Link />
                            <RichTextEditor.Unlink />
                        </RichTextEditor.ControlsGroup>

                        <RichTextEditor.ControlsGroup>
                            <RichTextEditor.AlignLeft />
                            <RichTextEditor.AlignCenter />
                            <RichTextEditor.AlignJustify />
                            <RichTextEditor.AlignRight />
                        </RichTextEditor.ControlsGroup>
                    </RichTextEditor.Toolbar>
                    <RichTextEditor.Content />
                </RichTextEditor>
                <Text weight={"bolder"}>Suivis : </Text>
                <Paper my={"md"} shadow="sm" p="xs" withBorder>
                    {(data.followUp.length > 0) ? data.followUp.map(i => <FollowUp suivi={i} />) : <Text> Aucun Suivi</Text>}
                </Paper>

                <Group position="center" spacing="xl" grow>
                    <Button color="grape" onClick={()=> {form.setFieldValue("description",editor.getHTML());patchChrono(form.values);refetch();navigate("/auth/chrono/"+data._id)}}> Modifier la Chrono</Button>
                </Group>
                </form>
            </Container>
)
}
return "loading"
}
